import React, { useState } from 'react';

// Painel de DEBUG (dev only) com a árvore + conteúdo do run dir do Panorama Jurídico.
// Recebe o dump via SSE 'panorama_debug' (gated por settings.panorama_debug no backend).
const PanoramaDebug: React.FC<{ data: any }> = ({ data }) => {
  const dump = (data && data.dump) || {};
  const tree: any[] = dump.tree || [];
  const files: Record<string, string> = dump.files || {};
  const [open, setOpen] = useState(false);

  return (
    <div style={{ border: '1px dashed #9aa', borderRadius: 8, margin: '8px 0', fontSize: 12, fontFamily: 'monospace' }}>
      <div
        onClick={() => setOpen(!open)}
        style={{ cursor: 'pointer', padding: '8px 10px', fontWeight: 600, userSelect: 'none' }}
      >
        🔍 Debug — arquivos do panorama ({tree.length}) {open ? '▾' : '▸'}
      </div>
      {open && (
        <div style={{ padding: '0 10px 10px', maxHeight: 520, overflow: 'auto' }}>
          <div style={{ opacity: 0.6, marginBottom: 8, wordBreak: 'break-all' }}>run: {dump.run_dir}</div>
          {tree.map((f: any, i: number) => (
            <details key={i} style={{ marginBottom: 4 }}>
              <summary style={{ cursor: 'pointer' }}>
                {f.path} <span style={{ opacity: 0.5 }}>({f.size}b)</span>
              </summary>
              <pre
                style={{
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  background: 'rgba(127,127,127,0.08)',
                  padding: 6,
                  marginTop: 4,
                  borderRadius: 4,
                }}
              >
                {files[f.path] != null ? files[f.path] : '(sem conteúdo)'}
              </pre>
            </details>
          ))}
        </div>
      )}
    </div>
  );
};

export default PanoramaDebug;
